<div
  class="bb"
  [class.bb--min]="minimized">
  <crm-notification-panel></crm-notification-panel>
</div>
